import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function WallStonePage() {
  return <ProductPageContent data={PRODUCT_PAGES["wall-stone"]} />;
}

export default WallStonePage;
